export const SystemPermissionNames = [
	'UseStudio',
	'UseDesignArea',
	'UseConfigurationArea',
	'UseDeploymentArea',
	'UseMonitoringArea',
	'UseAdministrationArea',
	'UseConsole',
	'UseNonMasterBranchesInStudio',
	'UseApps',
	'UseNonMasterBranchesInApps',
	'ViewBusinessObjects',
	'EditBusinessObjects',
	'ImportBusinessObjects',
	'ExportBusinessObjects',
	'EditDeploymentSources',
	'DeployFromDeploymentSources',
	'ViewSettings',
	'EditSettings',
	'EditBuildConfigurations',
	'EditTriggerConfigurations',
	'ViewTlsCertificates',
	'EditTlsCertificates',
	'ViewGeneralLog',
	'ViewUsers',
	'EditUsers',
	'EditLicense',
	'DownloadLicense',
	'EditIdentityProviders',
	'ReleaseOthersLocks',
	'SeeAllProcessTasks',
	'AssignProcessTasks',
	'UnassignProcessTasks',
	'RestartSystem',
	'All',
] as const
export type SystemPermissionName = (typeof SystemPermissionNames)[number]

export const SystemPermissionChildren: Partial<
	Record<SystemPermissionName, SystemPermissionName[]>
> = {
	EditBusinessObjects: ['ViewBusinessObjects'],
	EditSettings: ['ViewSettings'],
	EditTlsCertificates: ['ViewTlsCertificates'],
	EditUsers: ['ViewUsers'],
	All: SystemPermissionNames.filter((name) => name != 'All'),
}
